export default Object.freeze({
  CLINICAL_CATEGORY: 'C',
  MODALITY: 'M',
});
